export default "__VITE_PUBLIC_ASSET__cd424dbd__"